import React from "react";
import BrandName from "@/components/BrandName";

/**
 * Loading state = the NAVI CARE logo, centred on the page.
 *  - default: fills the whole screen (page / route loading)
 *  - fullscreen={false}: centred block inside a panel or card
 */
export default function BrandLoader({ fullscreen = true, className = "" }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      className={`navi-loader ${fullscreen ? "is-full" : "is-inline"} ${className}`}
      data-testid="brand-loader"
    >
      <BrandName services />
    </div>
  );
}
